import { Outlet } from 'react-router-dom'

import { CurrencyContextProvider } from 'modules/compensations/lib/CurrencyContext'
import { PayrollRunsProvider } from 'modules/compensations/lib/PayrollRunsContext'
import { COMPENSATIONS_SYNC_CONFIGURATION } from 'modules/compensations/pages/CompensationPage/SyncConfiguration'
import { CompensationsPayrollRun } from 'modules/compensations/pages/CompensationsPayrollRun'
import { IntegrationsSyncContextProvider } from 'modules/integrations/public'

const CompensationPage = () => {
  return (
    <PayrollRunsProvider>
      <CurrencyContextProvider>
        <IntegrationsSyncContextProvider configuration={COMPENSATIONS_SYNC_CONFIGURATION}>
          <CompensationsPayrollRun />
          <Outlet />
        </IntegrationsSyncContextProvider>
      </CurrencyContextProvider>
    </PayrollRunsProvider>
  )
}

export default CompensationPage
